<template>
  <div>
    <img class="w-100percent mt--2" src="@/assets/images/wave.svg"/>
    <div id="contact" class="bg-white container-wide mx-auto py-24">

      <div class="grid sm:grid-cols-1 lg:grid-cols-2 gap-4 mt-10">
        <div class="">
          <h6 class="text-secondary-500">
            - Get in Touch
          </h6>

          <h2 class="mt-4 max-w-screen-sm">
            Contact Us
          </h2>
        </div>

        <div class="">
          <div class="mt-4 flex">
            <div class="bg-gray-100 p-2 rounded-full h-16 w-16 flex align-center justify-center mr-6">
              <img src="@/assets/images/icons/calendar.svg"/>
            </div>

            <div class="flex-1">
              <p class="font-medium text-xl">
                Make an appointment
              </p>

              <p class="mt-4">
                When booking an appointment, all instructions will be explained clearly to you. <br> <br>
                <span class="text-navy-300">Call:</span> <a href="tel:+353874414492">00-35387-4414-492</a><br>
                <span class="text-navy-300">Email:</span> <a href="mailto:info@firstoptionsfertility.ie">info@firstoptionsfertility.ie</a>
              </p>

              <p class="mt-4">
                <a class="text-secondary-500" href="https://calendly.com/firstoptionsfertility" target="_blank">Make an appointment →</a>
              </p>
            </div>
          </div>

          <div class="mt-12 flex">
            <div class="bg-gray-100 p-2 rounded-full h-16 w-16 flex align-center justify-center mr-6">
              <img src="@/assets/images/icons/office.svg"/>
            </div>

            <div class="flex-1">
              <p class="font-medium text-xl">
                Where to find us
              </p>
              <p class="mt-4">
                <span class="font-medium block mb-1">Weekday clinics are held in</span> The Ultrasound Suite, Block B, The Palms, The Avenue Gorey Co Wexford.
                <br>
                <a
                  class="text-secondary-500 block mt-1"
                  href="https://www.google.com/maps/place/The+Ultrasound+Suite/@52.6745133,-6.2959792,15z/data=!4m2!3m1!1s0x0:0xa42cdf86855c7cbd?sa=X&ved=2ahUKEwjC49nMroX5AhXGTMAKHXIQCVAQ_BJ6BAhEEAU"
                  target="_blank"
                >
                  Get Directions →
                </a>
              </p>
              <p class="mt-6">
                <span class="font-medium block mb-1">Saturday clinics are held in</span>
                The Palms Health and Wellbeing Centre, Block C, The Avenue, Gorey, Co. Wexford.
                <br>
                <a
                  class="text-secondary-500 block mt-1"
                  href="https://www.google.com/maps/dir//The+Palms+GP+Surgery,+The+Avenue,+Gorey+corporation+lands,+Gorey,+Co.+Wexford/@52.6745893,-6.2955791,15z/data=!4m16!1m6!3m5!1s0x0:0x8f707b6ce4ded3eb!2sThe+Palms+GP+Surgery!8m2!3d52.6745893!4d-6.2955791!4m8!1m0!1m5!1m1!1s0x4867e65aaa2aaa17:0x8f707b6ce4ded3eb!2m2!1d-6.2955791!2d52.6745893!3e1"
                  target="_blank"
                >
                  Get Directions →
                </a>
              </p>
              <p class="mt-6 text-gray-600">
                We help clients from all over Ireland and are a short drive from Dublin, Wicklow, Carlow and Wexford.
              </p>

            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'ScaleServices',
  components: {
  },
}
</script>

<style scoped>
.service-card  {
  @apply bg-gray-100;
}

.mt--2 {
  margin-top: -2px;
}
</style>
